export default __webpack_public_path__ + "static/media/No40.8a20484f.jpg";